export const NOTIFICATION_REGISTER_DEVICE_REQUESTED = 'NOTIFICATION_REGISTER_DEVICE_REQUESTED';
export const NOTIFICATION_REGISTER_DEVICE_SUCCESS = 'NOTIFICATION_REGISTER_DEVICE_SUCCESS';
export const NOTIFICATION_REGISTER_DEVICE_FAILED = 'NOTIFICATION_REGISTER_DEVICE_FAILED';

// export const ALERT_DEVICE_UNREGISTER_REQUESTED = 'ALERT_DEVICE_UNREGISTER_REQUESTED';
// export const ALERT_DEVICE_UNREGISTER_SUCCESS = 'ALERT_DEVICE_UNREGISTER_SUCCESS';
// export const ALERT_DEVICE_UNREGISTER_FAILED = 'ALERT_DEVICE_UNREGISTER_FAILED';

export const NOTIFICATION_GET_LIST_REQUESTED = 'NOTIFICATION_GET_LIST_REQUESTED';
export const NOTIFICATION_GET_LIST_SUCCESS = 'NOTIFICATION_GET_LIST_SUCCESS';
export const NOTIFICATION_GET_LIST_FAILED = 'NOTIFICATION_GET_LIST_FAILED';

export const NOTIFICATION_GET_BADGES_REQUESTED = 'NOTIFICATION_GET_BADGES_REQUESTED';
export const NOTIFICATION_GET_BADGES_SUCCESS = 'NOTIFICATION_GET_BADGES_SUCCESS';
export const NOTIFICATION_GET_BADGES_FAILED = 'NOTIFICATION_GET_BADGES_FAILED';

export const NOTIFICATION_READ_REQUESTED = 'NOTIFICATION_READ_REQUESTED';
export const NOTIFICATION_READ_SUCCESS = 'NOTIFICATION_READ_SUCCESS';
export const NOTIFICATION_READ_FAILED = 'NOTIFICATION_READ_FAILED';

export const NOTIFICATION_READ_ALL_REQUESTED = 'NOTIFICATION_READ_ALL_REQUESTED';
export const NOTIFICATION_READ_ALL_SUCCESS = 'NOTIFICATION_READ_ALL_SUCCESS';
export const NOTIFICATION_READ_ALL_FAILED = 'NOTIFICATION_READ_ALL_FAILED';

export const NOTIFICATION_SEEN_ALL_REQUESTED = 'NOTIFICATION_SEEN_ALL_REQUESTED';
export const NOTIFICATION_SEEN_ALL_SUCCESS = 'NOTIFICATION_SEEN_ALL_SUCCESS';
export const NOTIFICATION_SEEN_ALL_FAILED = 'NOTIFICATION_SEEN_ALL_FAILED';

export const ALERT_LIST_CLEAR = 'ALERT_LIST_CLEAR';
export const ALERT_MINUS = 'ALERT_MINUS';
